import { Moment } from 'moment-timezone'
import React from 'react'
import styled from 'styled-components'

import { sortBasedOnSeverity } from 'helpers/alerts'

import AlertList from 'pages/shared/AlertList'

import { Alert } from 'types/Alert'
import { color } from 'styles/colors'

type Props = {
  alerts: Array<Alert>
  showDayRthCallback: (day: Moment) => void
}

const ActiveAlerts = ({ alerts, showDayRthCallback }: Props) => {
  sortBasedOnSeverity(alerts)
  return (
    <>
      {
        !alerts.length
          ? <S.NoActiveAlerts>No Alerts</S.NoActiveAlerts>
          : <AlertList alerts={alerts} showDayRthCallback={showDayRthCallback} />
      }
    </>
  )
}

export default ActiveAlerts

const S = {
  NoActiveAlerts: styled.h4`
    border-bottom: 0.6px solid ${color('borderGray')};
    padding: 20px 0;
    font-weight: normal;
    text-transform: capitalize;
    margin: 0 0 25px 0;
  `
}
